import * as XLSX from "xlsx"
import moment from "moment"

const formatDateTime = (millis) => (millis ? moment(millis).format("DD/MM/YYYY HH:mm") : "")

/**
 * Column widths for each sheet, in the order the row keys are written.
 */
const REDEMPTION_WIDTHS = [21, 22, 24, 30, 30, 18, 14, 12, 21, 36]
const REVERSAL_WIDTHS = [21, 21, 22, 24, 30, 30, 18, 14, 36]

const buildSheet = (rows, headers, widths) => {
	// An empty period still gets its headers, so the tab reads as "nothing
	// happened" rather than as a broken export
	const worksheet = rows.length > 0 ? XLSX.utils.json_to_sheet(rows) : XLSX.utils.aoa_to_sheet([headers])
	worksheet["!cols"] = widths.map((wch) => ({ wch }))

	return worksheet
}

/**
 * Download the partner's Stableford reconciliation report as a two-tab
 * workbook: points redeemed over the period, and redemptions voided over it.
 *
 * Points and cash values are left numeric rather than pre-formatted so finance
 * can sum and compare the columns against their own cash report directly.
 */
export default function exportRedemptions({ redemptions, reversals, start, end }) {
	const redemptionRows = redemptions.map((redemption) => ({
		"Redemption date": formatDateTime(redemption.created),
		"Booking reference": redemption.reference,
		"Client name": redemption.clientName,
		"Client email": redemption.clientEmail,
		"Redeemed by": redemption.redeemedBy,
		"Stableford points": Number(redemption.points || 0),
		"Value (GBP)": Number(redemption.valueGBP || 0),
		Status: redemption.voided ? "Voided" : "Applied",
		"Voided date": formatDateTime(redemption.voidedAt),
		"Partner note": redemption.note,
	}))

	const reversalRows = reversals.map((reversal) => ({
		"Voided date": formatDateTime(reversal.voidedAt),
		"Redemption date": formatDateTime(reversal.created),
		"Booking reference": reversal.reference,
		"Client name": reversal.clientName,
		"Client email": reversal.clientEmail,
		"Redeemed by": reversal.redeemedBy,
		"Stableford points": Number(reversal.points || 0),
		"Value (GBP)": Number(reversal.valueGBP || 0),
		"Void reason": reversal.voidReason,
	}))

	const workbook = XLSX.utils.book_new()

	XLSX.utils.book_append_sheet(
		workbook,
		buildSheet(redemptionRows, ["Redemption date", "Booking reference", "Client name", "Client email", "Redeemed by", "Stableford points", "Value (GBP)", "Status", "Voided date", "Partner note"], REDEMPTION_WIDTHS),
		"Redemptions"
	)

	XLSX.utils.book_append_sheet(
		workbook,
		buildSheet(reversalRows, ["Voided date", "Redemption date", "Booking reference", "Client name", "Client email", "Redeemed by", "Stableford points", "Value (GBP)", "Void reason"], REVERSAL_WIDTHS),
		"Reversals"
	)

	XLSX.writeFile(workbook, `Stableford_redemptions_${moment(start).format("YYYY-MM-DD")}_to_${moment(end).format("YYYY-MM-DD")}.xlsx`)
}
